export default __webpack_public_path__ + "static/media/active-green.d8fc07f1.svg";